// React & Hooks
import { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

// React Router
import { Outlet } from 'react-router-dom';
import { AppProvider } from '@toolpad/core/react-router-dom';

// Material-UI (MUI)
import { createTheme } from '@mui/material';

// Icons (MUI)
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import StoreIcon from '@mui/icons-material/Store';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
// Utilities
import { jwtDecode } from 'jwt-decode';

// Assets
import logo from './images/saleng shop white.png';


const NAVIGATION = [
  {
    kind: 'header',
    title: 'รายการหลัก',
  },
  // {
  //   title: 'หน้าแรก',
  //   icon: <DashboardIcon />,
  // },
  {
    segment: 'products',
    title: 'รายการสินค้า',
    icon: <LocalMallIcon />,
    pattern: 'products{/:actions}*',
  },
  {
    segment: 'branches',
    title: 'จัดการสาขา',
    icon: <StoreIcon />,
    pattern: 'branches{/:actions}*',
  },
  {
    segment: 'users',
    title: 'จัดการพนักงาน',
    icon: <PeopleAltIcon />,
    pattern: 'users{/:actions}*',
  },
  {
    kind: 'header',
    title: 'รายการอื่นๆ',
  },
  {
    segment: 'reports',
    title: 'ธุรกรรม',
    icon: <ReceiptLongIcon />,
    pattern: 'reports{/:actions}*',
  },
    {
    segment: 'member',
    title: 'เพิ่มสมาชิกสมาคม',
    icon: <CardMembershipIcon />,
    pattern: 'member{/:actions}*',
  },
  // {
  //   segment: 'stock',
  //   title: 'คลังสินค้า',
  //   icon: <StorefrontIcon />,
  //   pattern: 'stock{/:actions}*',
  // },
];

const theme = createTheme({
  typography: {
    fontFamily: '"IBM Plex Sans Thai", serif',
  },
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme',
  },
  colorSchemes: {
    light: {
      palette: {
        primary: { main: '#0B4DBA', dark: '#073783', light: '#EAF2FF' },
        background: { default: '#F5F7FB', paper: '#FFFFFF' },
        text: { primary: '#172033', secondary: '#5E6B82' },
      },
    },
    dark: {
      palette: {
        primary: { main: '#7FB0FF', dark: '#4B85E8', light: '#DCE9FF' },
        background: { default: '#111827', paper: '#182235' },
        text: { primary: '#F3F6FC', secondary: '#B8C3D6' },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 10px rgba(15, 47, 125, 0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
          textTransform: 'none',
        },
        contained: {
          boxShadow: 'none',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#0B4DBA',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#FFEA4E',
            color: '#172033',
            '&:hover': {
              backgroundColor: '#FFD700', // สีเมื่อ selected และ hover
            },
          },
          // '&.Mui-selected .MuiSvgIcon-root': {
          //   color: '#FFFFFF', // Change the color of the icon when selected
          // },
        },
      },
    },
    // MuiSvgIcon: {
    //   styleOverrides: {
    //     root: {
    //       color: '#FFFFFF', // Default color for all icons
    //     },
    //   },
    // },
  }
});

export default function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);

        // ตรวจสอบเวลาหมดอายุ (exp) กับเวลาปัจจุบัน
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          console.log("Token has expired");
          navigate('/auth/login');
        } else {
          setSession({
            user: {
              // name: "ทดสอบระบบ",
              // email: "admin@gmail.com",
              name: decoded.username,
              email: decoded.username + "@gmail.com",
              // image: <AccountCircleIcon />,
            },
          });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate('/auth/login');
      }
    } else {
      console.log("No access token found");
      navigate('/auth/login');
    }
  }, [navigate]);

  const [session, setSession] = useState({});

  const authentication = useMemo(() => {
    return {
      signIn: () => {
        setSession({
          user: {
            name: 'Admin1',
            email: 'Admin1@gmail.com',
            image: <AccountCircleIcon />,
          },
        });
      },
      signOut: async () => {
        localStorage.removeItem('accessToken');
        setSession(null);
        navigate('/auth/login');
      },
    };
  }, [navigate]);

  return (
    <AppProvider
      theme={theme}
      session={session}
      authentication={authentication}
      navigation={NAVIGATION}
      branding={{
        logo: <img src={logo} alt="SALENG Shop Logo" />,
        title: 'Admin'
        // title: <p style={{ color: "#FFF", marginTop: '18px' }}>ADMIN</p>
        // homeUrl: '/toolpad/core/introduction',
      }}
    >
      <Outlet />
    </AppProvider>
  );
}
